module.exports = __webpack_public_path__ + "media/svg-new/icon-rank2-b8ac561d.svg";